<!-- <p>dashboard-creation works!</p> -->
<div class="main-div">
    <div class="dashboard-div">
        <div class="dashboard-title alignRow">
            <mat-form-field style="width: 40%;">
                <mat-label>Dashboard Name</mat-label>
                <input (keyup)="nameChange($event)" matInput value="{{dashboardName}}" [readonly]="onLoadedDashboard">
            </mat-form-field>
            <button style="margin-left: 0.5em;" mat-raised-button [disabled]="defaultDashboard"
                (click)="setAsDefault()">{{!defaultDashboard ? 'Set as Organisation Default' :
                'Organisation Default'}}</button>
            <button *ngIf="loadedDashboard && allowEditing" [disabled]="!allowEditing" style="margin-left: 0.5em;"
                mat-raised-button (click)="deleteClicked()">Delete</button>
            <span class="toolbar-spacer"></span>

            <mat-icon *ngIf="allowEditing"
                [ngStyle]="{'color': (!deleting && !editing && !isSelecting) ? '' : 'lightgray'}"
                (click)="(!deleting && !editing && !isSelecting) ? adding = !adding : ''"
                matTooltip="{{(!deleting && !editing && !isSelecting) ? !adding ? 'Add New Panel' : 'Stop Adding' : ''}}">{{!adding
                ? "add" :
                "close"}}</mat-icon>
            <mat-icon *ngIf="allowEditing"
                [ngStyle]="{'color': (isSelecting && selectedPanels.length > 0) ? '' : 'lightgray'}"
                (click)="(isSelecting && selectedPanels.length > 0) ? copyPanels() : ''"
                matTooltip="{{(isSelecting && selectedPanels.length > 0) ? 'Copy Panels' : ''}}">content_copy</mat-icon>
            <mat-icon *ngIf="allowEditing && copiedPanels.length > 0" (click)="pastePanels()"
                matTooltip="Paste Panels">content_paste</mat-icon>
            <mat-icon *ngIf="allowEditing"
                [ngStyle]="{'color': panelInfo.length > 0 && (!adding && !deleting) ? '' : 'lightgray'}"
                matTooltip="{{(!adding && !deleting) ? !editing ? 'Edit Panel' : 'Stop Editing' : ''}}"
                (click)="panelInfo.length > 0 && (!adding && !deleting) ? enablePanelEditing() : ''">{{!editing ? "edit"
                : "edit_off"}}</mat-icon>
            <mat-icon *ngIf="allowEditing"
                [ngStyle]="{'color': (panelInfo.length > 0 && (!adding && !editing)) ? '' : 'lightgray'}"
                matTooltip="{{!deleting ? (panelInfo.length > 0 && (!adding && !editing)) ? 'Delete Panel' : '' : 'Stop Deleting'}}"
                (click)="(panelInfo.length > 0 && (!adding && !editing)) ? enablePanelDeleting() : ''">{{!deleting ?
                "delete" :
                "delete_forever"}}</mat-icon>
            <mat-icon *ngIf="allowEditing" [ngStyle]="{'color': checkDashboardValid() ? '' : 'lightgray'}"
                (click)="checkDashboardValid() ? saveDashboard() : ''"
                matTooltip="{{checkDashboardValid() ? 'Save Dashboard' : ''}}">save</mat-icon>
            <mat-icon *ngIf="allowEditing" matTooltip="{{!isSelecting ? 'Select' : 'Stop Selecting'}}"
                (click)="toggleSelection()">{{!isSelecting ? 'select_all' : 'deselect'}}</mat-icon>

            <button style="margin-left: 0.5em;" mat-raised-button (click)="newDashboard()"
                matTooltip="New Dashboard">New</button>
            <button style="margin-left: 0.5em;" mat-raised-button *ngIf="existingDashboards.length > 0"
                [matMenuTriggerFor]="loadDashboardMenu" matTooltip="Load Dashboard">Load</button>
            <mat-menu #loadDashboardMenu>
                <button mat-menu-item *ngFor="let dashboard of existingDashboards"
                    (click)="loadDashboard(dashboard)">{{dashboard.DashboardName}}</button>
            </mat-menu>
        </div>
        <hr>
        <ejs-dashboardlayout id='dashboardLayout' #dashboardLayout [columns]="maxColumns" [cellSpacing]='cellSpacing'
            [allowResizing]="allowEditing" [cellAspectRatio]='aspectRatio' [allowDragging]="allowEditing"
            [allowFloating]="false" [showGridLines]="true" (resizeStart)="startResize($event)"
            (resizeStop)="resizeFromDrag($event)" (dragStop)="dragStop($event)" (dragStart)="dragStart($event)"
            (click)="deleting ? deletePanel($event) : editing ? editPanel($event) : isSelecting ? selectPanel($event) : handleClick($event)"
            (created)="hideBottomGridRow()"
            [ngClass]="{'deleting': deleting, 'adding': adding, 'editing': editing, 'selecting': isSelecting}">
        </ejs-dashboardlayout>
    </div>
    <div class="data-model-div">
        <ejs-tab #tabs>
            <e-tabitems>
                <e-tabitem>
                    <ng-template #headerText>
                        <mat-icon>schema</mat-icon>&nbsp;Data Model
                    </ng-template>
                    <ng-template #content>
                        <app-organisation-data-model [onDashboardManagementPage]="true"
                            (dragComplete)="respondToDrag($event)"></app-organisation-data-model>
                    </ng-template>
                </e-tabitem>
                <e-tabitem>
                    <ng-template #headerText>
                        <mat-icon>account_tree</mat-icon>&nbsp;Hierarchy
                    </ng-template>
                    <ng-template #content>
                        <app-heirarchy-management [onDashboardCreationPage]="true"
                            (dragComplete)="respondToDrag($event, true)"></app-heirarchy-management>
                    </ng-template>
                </e-tabitem>
            </e-tabitems>
        </ejs-tab>
    </div>
</div>

<ng-template #defaultPanelTemplate>
    <div class="default-panel alignRow alignColumn">
        <!-- <button mat-button style="z-index: 9999999; background-color: whitesmoke; border: 1px solid lightgray;"
            (click)="newPanelClick($event)">
            <span>Add Widget</span>
            <mat-icon>add</mat-icon>
        </button> -->
        <span>Drag a node into this panel to create a widget.</span>
    </div>
</ng-template>

<ng-template #gaugePanelTemplate let-panelData="data" let-testingValue="testingValue ?? 4">
    <div style="width: 100%; height: 100%;" #parentDiv>
        <app-dashboard-gauge [panelData]="panelData" [refresh]="refreshGauges" [creating]="true" [titleMenu]="titleMenu"
            [testingValue]="testingValue"
            (borderChange)="respondToBorderChange(parentDiv, $event)"></app-dashboard-gauge>
    </div>
</ng-template>

<ng-template #annotatedGaugePanelTemplate let-panelData="data" let-testingValue="testingValue ?? 10">
    <div style="width: 100%; height: 100%;" #parentDiv>
        <app-dashboard-annotated-gauge style="height: 100%; width: 100%;" [panelData]="panelData"
            [refresh]="refreshGauges" [creating]="true" [titleMenu]="titleMenu" [testingValue]="testingValue"
            (borderChange)="respondToBorderChange(parentDiv, $event)"></app-dashboard-annotated-gauge>
    </div>
</ng-template>

<ng-template #chartPanelTemplate let-panelData="data">
    <app-dashboard-chart [panelData]="panelData" [creating]="true" [refresh]="refreshCharts" [numDays]="1"
        [titleMenu]="titleMenu" (seriesChange)="setDefaultSeries($event)"></app-dashboard-chart>
</ng-template>

<ng-template #textPanelTemplate let-panelData="data">
    <app-dashboard-text [panelData]="panelData" [creating]="true" [titleMenu]="titleMenu"></app-dashboard-text>
</ng-template>

<ng-template #listPanelTemplate let-panelData="data">
    <app-dashboard-list style="height: 100%; width: 100%;" [panelData]="panelData" [creating]="true"
        [titleMenu]="titleMenu"></app-dashboard-list>
</ng-template>

<ng-template #linearGaugePanelTemplate let-panelData="data" let-testingValue="testingValue ?? 10">
    <app-dashboard-linear-gauge [panelData]="panelData" [creating]="true" [titleMenu]="titleMenu"
        [testingValue]="testingValue"></app-dashboard-linear-gauge>
</ng-template>

<ng-template #shortcutPanelTemplate let-panelData="data">
    <app-dashboard-shortcut [panelData]="panelData" [creating]="true" [titleMenu]="titleMenu"></app-dashboard-shortcut>
</ng-template>

<ng-template #watchListPanelTemplate let-panelData="data">
    <app-dashboard-watch-list style="height: 100%; width: 100%;" [accountID]="accountGUID"
        [OrganisationUID]="organisationUID" [panelData]="panelData" [creating]="true"
        [titleMenu]="titleMenu"></app-dashboard-watch-list>
</ng-template>

<ng-template #actionsPanelTemplate let-panelData="data">
    <app-dashboard-action-list [accountID]="accountGUID" [organisationUID]="organisationUID"
        [onTemplateComponent]="true" [panelData]="panelData" [creating]="true"
        [titleMenu]="titleMenu"></app-dashboard-action-list>
</ng-template>

<ng-template #rulesPanelTemplate let-panelData="data">
    <app-dashboard-rules style="height: 100%; width: 100%;" [accountGUID]="accountGUID"
        [organisationUID]="organisationUID" [panelData]="panelData" [creating]="true"
        [titleMenu]="titleMenu"></app-dashboard-rules>
</ng-template>

<ng-template #eventsPanelTemplate let-panelData="data">
    <app-dashboard-events style="width: 100%; height: 100%;" [accountGUID]="accountGUID"
        [organisationUID]="organisationUID" [panelData]="panelData" [creating]="true"
        [titleMenu]="titleMenu"></app-dashboard-events>
</ng-template>

<ng-template #webhooksPanelTemplate let-panelData="data">
    <app-dashboard-webhooks style="width: 100%; height: 100%;" [accountGUID]="accountGUID"
        [organisationUID]="organisationUID" [panelData]="panelData" [creating]="true"
        [titleMenu]="titleMenu"></app-dashboard-webhooks>
</ng-template>

<mat-menu #titleMenu>
    <ng-template matMenuContent let-panelData="panelData">
        <mat-form-field appearance="fill" (click)="$event.stopPropagation()">
            <input matInput autocomplete="off" [value]="panelData.title" (change)="panelTitleChange($event, panelData)">
        </mat-form-field>
    </ng-template>
</mat-menu>